module.exports = __webpack_public_path__ + "img/quotation.d4953c2d.jpg";